// Update tax_id required attribute based on address country selection
// Tax ID is required if:
// - The rollout flag is active (regardless of address country), OR
// - Both space and address countries require it
export default function updateTaxIdRequirement() {
  const taxIdField = document.querySelector<HTMLInputElement>(
    'input[name*="[tax_id]"]',
  );
  const countrySelect = document.querySelector<HTMLSelectElement>(
    'select[data-country-for-tax-id-validation]',
  );

  if (!taxIdField || !countrySelect) {
    return;
  }

  const rolloutRequiresTaxId =
    taxIdField.dataset.rolloutRequiresTaxId === 'true';
  const spaceCountryRequiresTaxId =
    taxIdField.dataset.spaceCountryRequiresTaxId === 'true';
  const countriesRequiringTaxId = JSON.parse(
    taxIdField.dataset.countriesRequiringTaxId || '[]',
  ) as string[];

  function updateRequirement() {
    const selectedCountry = countrySelect!.value;
    const addressRequiresTaxId =
      countriesRequiringTaxId.includes(selectedCountry);

    // If rollout is active, require regardless of address country
    // Otherwise, require if both space and address countries require it
    const shouldBeRequired =
      rolloutRequiresTaxId ||
      (spaceCountryRequiresTaxId && addressRequiresTaxId);

    taxIdField!.required = shouldBeRequired;

    // Also update aria-required for accessibility
    if (shouldBeRequired) {
      taxIdField!.setAttribute('aria-required', 'true');
    } else {
      taxIdField!.removeAttribute('aria-required');
    }
  }

  // Update on initial load
  updateRequirement();

  // Update when country changes
  countrySelect!.addEventListener('change', updateRequirement);
}
